export const SECRET_KEY_STEP: number = 1;

export const VERIFY_TOKEN_STEP: number = 2;
